import { Link, Outlet, createFileRoute } from "@tanstack/react-router"
import { Brand } from "@/components/public-navbar"

export const Route = createFileRoute("/_auth")({
  component: AuthenticationLayout,
})

function AuthenticationLayout() {
  return (
    <div className="auth-shell">
      <header className="auth-header">
        <Link to="/" reloadDocument aria-label="intoshort, home">
          <Brand />
        </Link>
      </header>
      <Outlet />
    </div>
  )
}
